const productBundleSettings = JSON.parse(window.localStorage.getItem('productBundle'));

export {
    productBundleSettings
}